import script from "./EmailSmsTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSmsTemplates.vue?vue&type=script&setup=true&lang=js"

import "./EmailSmsTemplates.vue?vue&type=style&index=0&id=2bc10989&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc10989"]])

export default __exports__